(function () {
    'use strict';
    var controllerId = 'dipendenteSelectSuper';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', '$uibModalInstance', 'datacontext','dipendenti', dipendenteSelectSuperFn]);

    function dipendenteSelectSuperFn($scope, $rootScope, $uibModalInstance, datacontext, dipendenti) {
        $scope.item = {};
        $scope.item.fTesto = '';
        $scope.item.dipendenti = dipendenti;
        $scope.item.selected = selected;
        //$scope.item.cerca = getDipendenti;
        $scope.item.loading = false;

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
                
        function selected(id, nominativo) {
            var resultItem = { 'id': id, 'nominativo': nominativo };
            $uibModalInstance.close(resultItem);
        }

        //function getDipendenti() {
        //    $scope.item.loading = true;
        //    return datacontext.dipendente_getAll(0, 0, 0, $scope.item.fTesto, 0, '').then(function (data) {                
        //        //Se è supervisore torno solo i dipendenti senza username settata
        //        var dip = [];
        //        if ($rootScope.isAuthorized('SUPER')) {                    
        //            if (data.constructor === Array) {
        //                data.forEach(function (item) {
        //                    if (item.Ruolo == null || item.Ruolo == undefined || item.Ruolo.trim().length == 0)
        //                        dip.push(item);
        //                });
        //            }
        //        }
        //        else
        //            dip = data;

        //        $scope.item.loading = false;
        //        return $scope.item.dipendenti = dip;
        //    });
        //}
    }
})();